<template>
  <div>
    <div class="row">
      <div class="col-lg-3 p-2">
        <div class="wrapperDataOwner">
          <h4>Prenotazioni</h4>
          <h5><i class="far fa-calendar-alt"></i><span class="numb">{{ datas.bookings }}</span></h5>
        </div>
      </div>
      <div class="col-lg-3 p-2">
        <div class="wrapperDataOwner">
          <h4>Ospiti accolti</h4>
          <h5><i class="fas fa-users"></i><span class="numb">{{ datas.guests }}</span></h5>
        </div>
      </div>
      <div class="col-lg-3 p-2">
        <div class="wrapperDataOwner">
          <h4>Notti occupate</h4>
          <h5><i class="fas fa-moon"></i><span class="numb">{{ datas.nights }}</span></h5>
        </div>
      </div>
      <div class="col-lg-3 p-2">
        <div class="wrapperDataOwner">
          <h4>Netto</h4>
          <h5><i class="fas fa-euro-sign"></i><span class="numb">{{ datas.netto }}</span></h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HouseCardsHome",
  props: ['houseId', 'year'],
  data() {
    return {
      datas: []
    }
  },
  methods: {
    getCardDatas() {
      axios.get('/api/get-house-cards/' + this.houseId + '/' + this.year)
          .then(response => {
                this.datas = response.data.body;
              }
          )
    }
  },
  mounted() {
    this.getCardDatas()
  }
}
</script>

<style scoped>
h2, .far, .fas {
  color: #E94E1B !important;
}

.numb {
  font-size: 32px !important;
  color: #29235C !important;
  padding-left: 20px;
  font-weight: 700;
}
</style>